<template>
  <div class="flex flew-row">
    <NumericInput
      :value="localWeightInPounds"
      min="0"
      max="1500"
      aria-label="pounds"
      inputId="weightMajor"
      :input-style="inputStyle"
      :measurement-indicator="measurementIndicators.pounds"
      @input="localWeightInPounds = $event"
      @blur="$emit('blur')"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { validateInput } from "../../SimpleBmiQuestion/validation";
import NumericInput from "./NumericInput.vue";
import { ImperialWeightMeasurementIndicators } from "../../../types";

export default Vue.extend({
  components: { NumericInput },
  props: {
    weightInPounds: { type: Number, required: true },
    inputStyle: { type: String, required: true },
    measurementIndicators: { type: Object as PropType<ImperialWeightMeasurementIndicators>, required: true },
  },
  computed: {
    localWeightInPounds: {
      get() {
        return this.weightInPounds;
      },
      set(value) {
        const emitValue = validateInput(value, 1500);
        this.$emit("update:weightInPounds", emitValue);
      },
    },
  },
});
</script>
